var addWeeks = require('../add_weeks/index.js')

/**
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, amount) {
  return addWeeks(dirtyDate, -amount)
}

module.exports = subWeeks



//////////////////
// WEBPACK FOOTER
// ./~/date-fns/sub_weeks/index.js
// module id = 44
// module chunks = 0